export { default as Discounts } from './Discounts';



// WEBPACK FOOTER //
// ./src/discounts/index.js